VjsAdmin.Modal = (function () {
    const template = `
        <div class="modal fade">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"></h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body" ></div>
                </div>
            </div>
        </div>
    `;

    const create = function (params) {
        const $modal = $(template);

        if (typeof params.id !== 'undefined') {
            $modal.attr('id', params.id);
        }
        if (typeof params.classes !== 'undefined') {
            $modal.addClass(params.classes);
        }
        if (typeof params.title !== 'undefined') {
            $modal.find('.modal-title').append(params.title);
        }
        if (typeof params.body !== 'undefined') {
            $modal.find('.modal-body').append(params.body);
        }
        if (typeof params.footer !== 'undefined') {
            $modal.find('.modal-content').append('<div class="modal-footer"></div>');
            $modal.find('.modal-footer').append(params.footer);
        }
        if (typeof params.no_close !== 'undefined' && params.no_close === true) {
            $modal.find('.modal-header .close').remove();
        }

        // register any custom event handlers
        if (typeof params.onShow === 'function') {
            $modal.on('show.bs.modal', function (e) {
                params.onShow.call(this, e);
            });
        }
        if (typeof params.onShown === 'function') {
            $modal.on('shown.bs.modal', function (e) {
                params.onShown.call(this, e);
            });
        }
        if (typeof params.onHide === 'function') {
            $modal.on('hide.bs.modal', function (e) {
                params.onHide.call(this, e);
            });
        }
        if (typeof params.onHidden === 'function') {
            $modal.on('hidden.bs.modal', function (e) {
                params.onHidden.call(this, e);
            });
        }

        // add the background blur when modal is opened
        $modal.on('hidden.bs.modal', () => {
            // blur out the background
            $('.app-body').addClass('blur');
        });

        // remove the background blur when modal is closed
        $modal.on('hidden.bs.modal', () => {
            $('.app-body').removeClass('blur');
        });

        return $modal;
    };

    return {
        create,
    };
}());
